<!--
 * @Author: zl
 * @Date: 2022-12-13 17:08:36
 * @LastEditTime: 2022-12-29 16:21:32
 * @LastEditors: zl
 * @Description: 数据角色权限
-->
<template>
	<div class='DataRolePermissionsIndex-layout'>
		<w-split v-model="splitValue">
			<div slot="left"
				 class="left">
				<div class="primary-layout">
					<div class='primary-header'>
						<div class='left-text text-overflow'>角色列表</div>
						<div class='btnGroups'>
							<el-button type="primary"
									   size="small"
									   icon="el-icon-plus"
									   @click="roleClick('add')"
									   v-if="roleBtns.includes('add_role')">新增</el-button>
						</div>
					</div>
					<div class='primary-content w-table-layout mt10'>
						<div class='w-table-content'>
							<vxe-table align="center"
									   border
									   :data="leftTable.data"
									   height="100%"
									   highlight-hover-row
									   highlight-current-row
									   :loading="leftTable.loading"
									   ref="leftTable"
									   show-overflow="tooltip"
									   show-header-overflow="tooltip"
									   @current-change="leftClick">
								<vxe-column field="roleName"
											title="角色名称"
											min-width="130"></vxe-column>
								<vxe-column field="roleTypeName"
											title="角色类型"
											min-width="130"></vxe-column>
								<!-- <vxe-column field="limitName"
											title="主体类型"
											min-width="130"></vxe-column> -->
								<vxe-column title="操作"
											min-width="95">
									<template #default="{ row }">
										<vxe-button type="text"
													status="primary"
													@click="roleClick('edit', row)"
													title="编辑角色"
													v-if="roleBtns.includes('edit_role')">
											<svg-icon icon-class="form-edit"></svg-icon>
										</vxe-button>
										<vxe-button type="text"
													status="danger"
													@click="roleClick('delete', row)"
													title="删除角色"
													v-if="roleBtns.includes('delete_role')">
											<svg-icon icon-class="form-delete"></svg-icon>
										</vxe-button>
									</template>
								</vxe-column>
							</vxe-table>
						</div>
					</div>
				</div>
			</div>
			<div slot="right"
				 class="right">
				<div class="primary-layout">
					<div class='primary-header'>
						<div class='left-text text-overflow'>该角色具有查看操作权限的项目列表</div>
						<div class='btnGroups'>
							<el-button type="primary"
									   plain
									   size="small"
									   @click="openDialog('directly')"
									   v-if="roleBtns.includes('directly')">直接配置</el-button>
							<el-button type="success"
									   plain
									   size="small"
									   @click="openDialog('conditions')"
									   v-if="roleBtns.includes('conditions')">条件配置</el-button>
							<el-input v-model="searchForm.sname"
									  size="small"
									  placeholder="请输入项目名称"
									  clearable
									  class="custom-input-inner ml10">
								<el-button class="btn-success"
										   size="small"
										   slot="append"
										   @click="submitForm">查询</el-button>
							</el-input>

							<!-- 弹出框搜素区域 -->
							<el-popover placement="bottom-end"
										width="415"
										trigger="click">
								<el-form ref="searchForm"
										 :model="searchForm"
										 size="small"
										 label-width="100px">
									<el-form-item label="建设单位"
												  prop="constructionUnit">
										<el-select v-model="searchForm.constructionUnit"
												   placeholder="请选择"
												   clearable>
											<el-option v-for="(item, index) in constructionUnitList"
													   :key="index"
													   :label="item.sname"
													   :value="item.id"></el-option>
										</el-select>
									</el-form-item>
									<el-form-item label="项目类型"
												  prop="proType">
										<el-select v-model="searchForm.proType"
												   placeholder="请选择"
												   clearable>
											<el-option v-for="item in projectDict.dxxmlx"
													   :key="item.id"
													   :label="item.sname"
													   :value="item.value"></el-option>
										</el-select>
									</el-form-item>
									<el-form-item label="建设类型"
												  prop="constructionType">
										<el-select v-model="searchForm.constructionType"
												   placeholder="请选择"
												   clearable>
											<el-option v-for="item in projectDict.dxjslx"
													   :key="item.id"
													   :label="item.sname"
													   :value="item.value"></el-option>
										</el-select>
									</el-form-item>
									<el-form-item label="项目归属区域"
												  prop="isNorth">
										<el-select placeholder="请选择"
												   v-model="searchForm.isNorth"
												   size="small">
											<el-option v-for="item in projectDict.xmgsqy"
													   :key="item.id"
													   :value="item.value"
													   :label="item.sname"></el-option>
										</el-select>
									</el-form-item>
									<el-form-item label-width="0"
												  class="text-center borderTop">
										<el-button type="primary"
												   icon="el-icon-search"
												   @click="submitForm">查询</el-button>
										<el-button icon="el-icon-refresh"
												   @click="resetForm">重置</el-button>
									</el-form-item>
								</el-form>
								<el-button type="success"
										   size="small"
										   slot="reference"
										   icon="el-icon-arrow-down"
										   class="ml10 mr10 btn-success"></el-button>
							</el-popover>
							<el-button icon="el-icon-menu"
									   type="primary"
									   size="small"
									   @click="doFilter">列过滤</el-button>
						</div>
					</div>
					<div class='primary-content w-table-layout mt10'>
						<div class='w-table-content'>
							<vxe-table align="center"
									   border
									   :data="rightTable.data"
									   height="100%"
									   highlight-hover-row
									   highlight-current-row
									   :loading="rightTable.loading"
									   ref="rightTable"
									   show-overflow="tooltip"
									   show-header-overflow="tooltip">
								<vxe-column type="seq"
											title="序号"
											width="60"></vxe-column>
								<vxe-column field="sname"
											title="项目名称"
											header-align="center"
											align="left"
											min-width="200"></vxe-column>
								<vxe-column field="proNo"
											title="项目编号"
											:visible="false"
											width="160"></vxe-column>
								<vxe-column field="shortName"
											title="建设单位"
											header-align="center"
											align="left"
											width="140">
									<template #default="{ row }">
										<el-tooltip :content="row.tenantName"
													placement="top"
													effect="dark">
											<span>{{ row.shortName }}</span>
										</el-tooltip>
									</template>
								</vxe-column>
								<vxe-column field="userName"
											title="建设单位项目负责人"
											width="160"></vxe-column>
								<vxe-column field="newProTypeName"
											title="项目类型"
											width="120"></vxe-column>
								<vxe-column field="constructionTypeName"
											title="建设类型"
											width="120"></vxe-column>
								<vxe-column field="isNorthName"
											title="项目归属区域"
											width="110"></vxe-column>
								<vxe-column field="proTotalValue"
											title="项目总投资(万元)"
											width="130"
											header-align="center"
											align="right"
											:visible="false"></vxe-column>
								<vxe-column field="planStartTime"
											title="计划开竣工时间"
											width="190">
									<template #default="{ row }">
										<span v-if="row.planStartTime">
											{{ row.planStartTime.substring(0, 10) }}
										</span>
										<span v-if="row.planEndTime">
											到 {{ row.planEndTime.substring(0, 10) }}
										</span>
									</template>
								</vxe-column>
							</vxe-table>
						</div>
					</div>
				</div>
			</div>
		</w-split>

		<!-- 列过滤弹窗 -->
		<ColumnFilter v-if="showFilter"
					  ref="filterColumn"
					  :filterColumns="filterColumns"
					  @onFilter="onFilter"></ColumnFilter>

		<!-- 直接配置/条件配置 -->
		<Dialog v-if="dialogShow"
				ref="handleDialog"
				:dialogType="dialogType"
				:roleId="leftTable.currentRow.id"
				@closed="closed"></Dialog>

		<!-- 左侧弹窗，新增/编辑弹窗 -->
		<el-dialog :close-on-click-modal="false"
				   center
				   :title="dialog.title"
				   :visible.sync="dialog.show"
				   width="800px"
				   :before-close="dialogClose"
				   :destroy-on-close="true">
			<el-form :model="dialog.form"
					 label-width="100px"
					 ref="dialogForm"
					 size="small">
				<el-form-item label="角色名称"
							  prop="roleName"
							  :rules="requireRule">
					<el-input v-model="dialog.form.roleName"
							  placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="角色类型"
							  prop="roleType">
					<el-input v-model="dialog.form.roleTypeName"
							  disabled></el-input>
				</el-form-item>
				<!-- <el-form-item label="选择主体"
							  prop="limitId">
					<el-select v-model="dialog.form.limitId"
							   placeholder="请选择">
						<el-option v-for="item in roleLimit"
								   :key="item.id"
								   :label="item.sname"
								   :value="item.id">
						</el-option>
					</el-select>
					<p v-if="roleLimit.length == 0"
					   class="red-text">*请先维护好【主体管理】中主体列表信息，然后再选择主体</p>
				</el-form-item> -->
				<el-form-item label="备注信息"
							  prop="remark">
					<el-input v-model="dialog.form.remark"
							  type="textarea"
							  :autosize="{ minRows: 5 }"
							  placeholder="请输入"
							  maxlength="200"
							  show-word-limit></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer">
				<el-button @click="dialogClose"
						   class="btn">取消</el-button>
				<el-button type="primary"
						   class="btn"
						   :loading="dialog.loading"
						   @click="dialogSure">确定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { selectAll } from '@/api/system/roleLimit'
import * as API from '@/api/system/DataRole'
import ColumnFilter from '@/views/Common/ColumnFilter'
import Dialog from '@/views/DataRolePermissions/components/Dialog'
export default {
	props: {},
	components: { ColumnFilter, Dialog },
	data() {
		return {
			splitValue: 0.3,
			leftTable: {
				data: [],
				loading: false,
				currentRow: {},
			},
			rightTable: {
				data: [],
				loading: false,
			},
			searchForm: {
				sname: '', //工程项目名称
				constructionUnit: '', //建设单位
				proType: '', //项目类型
				constructionType: '', //建设类型
				isNorth: '', //项目归属区域
				roleId: '', //数据角色ID
			},
			constructionUnitList: [], //建设单位列表
			// 列过滤对象数组
			showFilter: false,
			filterColumns: [
				{
					title: '',
					checkAll: false,
					columns: [],
				},
			],
			dialogShow: false, //弹窗展示
			dialogType: '', //弹窗类别
			dialog: {
				title: '',
				type: '',
				show: false,
				loading: false,
				form: {
					roleName: '', //角色名称
					roleType: '1003001', //角色类型
					roleTypeName: '项目外公共角色', //角色类型名称
					limitId: '', //备注
					remark: '', //主体ID
					id: '',
				},
			},
			requireRule: [{ required: true, message: '不能为空' }],
			roleLimit: [], //主题列表数据
		}
	},
	created() {
		// 获取数据角色列表
		this.getRoleList(true)
		// 获取主体列表
		// this.selectAll()
	},
	mounted() {},
	methods: {
		/**********   准备工作   **********/

		// 获取数据角色列表
		getRoleList(first) {
			this.leftTable.loading = true
			API.selectDataRole({})
				.then((res) => {
					this.leftTable.data = res.data
					this.leftTable.loading = false
					if (first && res.data.length > 0) {
						this.leftTable.currentRow = res.data[0]
						this.$refs.leftTable.setCurrentRow(res.data[0])
						this.getProjectListByRole()
						this.getCompanyList()
					}
				})
				.catch(() => {
					this.leftTable.loading = false
				})
		},

		// 根据单位类型查询单位
		getCompanyList() {
			API.getConstructionUnitByRole({
				roleId: this.leftTable.currentRow.id,
			}).then((res) => {
				this.constructionUnitList = res.data
			})
		},

		// 获取主体列表
		selectAll() {
			selectAll({}).then((res) => {
				this.roleLimit = res.data.limits
			})
		},

		// 查询数据角色下的配置项目
		getProjectListByRole() {
			let params = this.$utils.clone(this.searchForm, true)
			params.roleId = this.leftTable.currentRow.id
			this.rightTable.loading = true
			API.getProjectListByRole(params)
				.then((res) => {
					this.rightTable.loading = false
					this.rightTable.data = res.data
				})
				.catch(() => {
					this.rightTable.loading = false
				})
		},

		/**********   列过滤   **********/

		// 点击列过滤
		doFilter() {
			// 列过滤对象数组
			let tableShowColumn = this.$refs.rightTable.getTableColumn()
			let collectColumn = tableShowColumn.collectColumn
			collectColumn.shift()
			this.$set(this.filterColumns[0], 'columns', collectColumn)
			this.showFilter = true
			setTimeout(() => {
				this.$refs.filterColumn.dialogObj.visible = true
			}, 200)
		},

		// 确认列过滤
		onFilter(arr) {
			if (this.$refs.rightTable) {
				// 确定赋值
				this.$set(this, 'filterColumns', arr)
				this.$refs.rightTable.refreshColumn()
				this.getProjectListByRole()
			}
		},

		/**********   左侧相关操作   **********/

		// 新增角色
		async roleClick(type, row) {
			if (type != 'delete') {
				this.dialog.show = true
				this.dialog.type = type
			}
			switch (type) {
				case 'add':
					this.dialog.title = '新增角色'
					break
				case 'edit':
					this.dialog.title = '编辑角色'
					this.$nextTick(() => {
						this.dialog.form = this.$utils.clone(row, true)
					})
					break
				case 'delete':
					let status = await this.$deleteConfirm('确认删除吗？', true)
					if (status) {
						this.leftTable.loading = true
						API.deleteDataRole({
							roleId: row.id,
						})
							.then((res) => {
								this.getRoleList()
							})
							.catch(() => {
								this.leftTable.loading = false
							})
						return
					}
					this.$message.info('操作已取消！')
					break
			}
		},

		// 表格点击
		leftClick({ row }) {
			this.leftTable.currentRow = this.$utils.clone(row, true)
			this.getProjectListByRole()
		},

		/**********   右侧按钮操作   **********/

		// 打开弹窗
		openDialog(type) {
			if (Object.keys(this.leftTable.currentRow).length <= 0) {
				this.$message.warning('请选选择要配置的角色！')
				return
			}
			this.dialogType = type
			this.dialogShow = true
			setTimeout(() => {
				this.$refs.handleDialog.open()
			}, 200)
		},

		// 接收
		closed() {
			this.dialogShow = false
			this.getProjectListByRole()
		},

		// 表单搜索
		submitForm() {
			this.getProjectListByRole()
		},

		// 重置表单
		resetForm() {
			this.searchForm.sname = ''
			this.$refs.searchForm.resetFields()
			this.getProjectListByRole()
		},

		/**********   弹窗相关   **********/

		// 弹窗关闭
		dialogClose() {
			this.$refs.dialogForm.resetFields()
			this.dialog.form.id = ''
			this.dialog.title = ''
			this.dialog.type = ''
			this.dialog.loading = false
			this.dialog.show = false
		},

		// 弹窗提交
		dialogSure() {
			this.$refs.dialogForm.validate((valid) => {
				if (valid) {
					let params = this.$utils.clone(this.dialog.form, true)
					this.dialog.loading = true
					API.saveOrUpdateDataRole(params)
						.then((res) => {
							this.$message.success('新增完成！')
							this.dialogClose()
							this.getRoleList()
						})
						.catch(() => {
							this.dialog.loading = false
						})
					return
				}
				this.$message.error('请完善表单！')
			})
		},
	},
	computed: {
		// 码表
		...mapState('dict', {
			projectDict: (state) => state.projectDict,
		}),

		// 按钮权限
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
	},
}
</script>

<style lang='less' scoped>
.DataRolePermissionsIndex-layout {
	height: 100%;
	.left,
	.right {
		padding: 15px;
		height: 100%;
	}
	.left-text {
		font-weight: bolder;
		color: #000;
		font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑';
	}
	.el-form-item {
		margin-bottom: 15px !important;
	}
	.red-text {
		color: #ff0000;
	}
}
</style>